// Geteilte Monitoring-Cam-Kachel: zeigt einen Remote-Video-Track ODER (track=null) eine benannte
// „kein Bild"-Kachel. Reconnect-Spinner self-contained über das `mute`/`unmute`-Event des Remote-Tracks —
// stockt der Sender (Reconnect, Encoder-Aussetzer), feuert der Track `mute` → Overlay; bei `unmute` wieder weg.
import { useEffect, useRef, useState } from 'react';
import styles from './CamTile.module.css';

export function CamTile({ track, label }: { track: MediaStreamTrack | null; label?: string }) {
  const ref = useRef<HTMLVideoElement | null>(null);
  const [stalled, setStalled] = useState(track?.muted ?? false);

  useEffect(() => {
    if (!track) return;
    const v = ref.current;
    if (v) { v.srcObject = new MediaStream([track]); void v.play().catch(() => {}); }
    setStalled(track.muted);
    const onMute = () => setStalled(true);
    const onUnmute = () => setStalled(false);
    track.addEventListener('mute', onMute);
    track.addEventListener('unmute', onUnmute);
    return () => { track.removeEventListener('mute', onMute); track.removeEventListener('unmute', onUnmute); };
  }, [track]);

  if (!track) {
    return (
      <div className={`${styles.tile} ${styles.noVideo}`}>
        <i className="ph ph-video-camera-slash" aria-hidden="true" />
        {label && <div className={styles.label}>{label}</div>}
      </div>
    );
  }
  return (
    <div className={styles.tile}>
      <video ref={ref} className={styles.video} playsInline muted />
      {stalled && <div className={styles.overlay}><div className={styles.spinner} />reconnecting…</div>}
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
}
